<template>
  <h2 :class="cssClass">
    NYBG
  </h2>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    cssClass:{
      type:String,
      default:''
    }
  }
}
</script>

<style lang="scss" scoped>
h2{
	font-size: 60px;
}
</style>
